import { ReactNode } from 'react';
import { ErrorBoundary as BaseErrorBoundary } from 'react-error-boundary';

interface FallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const Fallback = ({ error, resetErrorBoundary }: FallbackProps) => (
  <div>
    <p>Something went wrong:</p>
    <pre>{error.message}</pre>
    <button onClick={resetErrorBoundary}>Try again</button>
  </div>
);

interface ErrorBoundaryProps {
  children: ReactNode;
  onReset?: () => void;
}

const ErrorBoundary = ({ children, onReset, ...props }: ErrorBoundaryProps) => (
  <BaseErrorBoundary
    FallbackComponent={Fallback}
    onReset={onReset} // reset the state of your app so the error doesn't happen again
    {...props}
  >
    {children}
  </BaseErrorBoundary>
);

export default ErrorBoundary;
